import { MMBDatalayerConstants } from "@src/components/services/ib-MmB-datalayer/constants/ib-MmB-datalayer-constants";

(function () {
    'use strict';

    angular
        .module('ib-MmB-modal-module')
        .controller('MmBPassengerModalController', MmBPassengerModalController);
    MmBPassengerModalController.$inject = ['$uibModalInstance', 'object', 'MmBDatalayerUtilsService', 'MmBAppConstants', 'MmBUtilService', 'BookingDashboardService', '$timeout', '$rootScope', 'localStorageService', '$filter', '$scope', '$translate', 'CommonsUserUtilsService','CommonsUtilService'];
    function MmBPassengerModalController ($uibModalInstance, object, MmBDatalayerUtilsService, MmBAppConstants, MmBUtilService, BookingDashboardService, $timeout, $rootScope, localStorageService, $filter, $scope, $translate, CommonsUserUtilsService, CommonsUtilService) {
        var vm = this;
        vm.model = object;
        vm.modelOld = object;
        vm.$onInit = activate;
        vm.checked = checked;
        vm.close = closeModal;
        vm.specialNeedsChange = false;
        vm.areEmailsEquals = areEmailsEquals;
        vm.updateEmergencyContactInfo = updateEmergencyContactInfo;
        vm.updateFrequentFlyerContactInfo = updateFrequentFlyerContactInfo;
        vm.updateSpecialNeedsContactInfo = updateSpecialNeedsContactInfo;
        vm.updateDataContact = updateDataContact;
        vm.resetOriginalSpecialNeeds = resetOriginalSpecialNeeds;
        vm.checkStatusSVAN = checkStatusSVAN;
        vm.updatePersonalInfo = updatePersonalInfo;
        vm.checkPersonalInfoChanges = checkPersonalInfoChanges;
        vm.disableUpdatePersonaInfoAction = true;
        $scope.$on('$destroy', resetOriginalSpecialNeeds);

        /**
         * Initialize modal controller
         */
        function activate () {
            var tagsInfo;
            var quadrigam;
            vm.model.submitted = false;
            vm.model.showError = false;
            vm.model.showOk = false;
            vm.model.showErrorForm = false;
            vm.model.passengersModelCopy = angular.copy(vm.model.serviceData);
            vm.model.showPatternError = false;
            vm.modelOld = angular.copy(vm.model.specialNeeds);
            vm.model.prefixesList = localStorageService.get('phoneCodeList');
            if (vm.model.type === 'contactInfo') {
                vm.model.email = (vm.model?.contactInfo?.email) ? vm.model.contactInfo.email : '';
                vm.model.phone = (vm.model?.contactInfo?.phoneDetails) ? (vm.model?.contactInfo?.phoneDetails?.countryCode) + (vm.model?.contactInfo?.phoneDetails?.number) : '';
                vm.model.phoneDetails = (vm.model?.contactInfo?.phoneDetails) ?? {};
                vm.model.phoneDetails.countryCode = vm.model?.contactInfo?.phoneDetails?.countryCode ? vm.model.contactInfo.phoneDetails.countryCode : MmBUtilService.getPrefixFromMarket().code;
                vm.model.phoneDetails.number = vm.model?.contactInfo?.phoneDetails?.number ? vm.model.contactInfo.phoneDetails.number : '';
                vm.model.countryCode = (vm.model?.contactInfo?.countryCode) ? vm.model.contactInfo.countryCode : MmBUtilService.getPrefixFromMarket().code;
                vm.model.emailRepeat = '';
            }

            if (vm.model.type === 'personalInfo') {
                quadrigam = MmBAppConstants.QUADRIGAM.MODAL_CORRECTION_NAME;
                MmBDatalayerUtilsService.updateDatalayerInfo(MMBDatalayerConstants.DIGITAL_DATA_PROCESS[quadrigam],MMBDatalayerConstants.DIGITAL_DATA_STEP[quadrigam], quadrigam);
            }
            if (angular.isObject(vm.model.specialNeeds) && angular.isString(vm.model.specialNeeds.specialGuideDogStatus) && vm.model.specialNeeds.specialGuideDogStatus !== MmBAppConstants.SPECIAL_NEEDS.SVAN_STATUS.DEFAULT.code) {
                $translate.onReady().then(() => {
                    $translate.use($rootScope.appLang);
                    tagsInfo = {
                        link: {
                            tag: 'a',
                            href: $filter('LinksFilter')('SPECIAL_NEED_DOG_GUIDE_INFO'),
                            target: '_blank',
                            title: $filter('translate')('IB_PASSENGER_SPE_NEEDS_CHECK_SPECIAL_GUIDE_DOG_INFO_MESSAGE_LINK'),
                            class: 'ib-link ib-link--underline'
                        }
                    };

                    if (vm.model.specialNeeds.specialGuideDogStatus === MmBAppConstants.SPECIAL_NEEDS.SVAN_STATUS.HK.code || vm.model.specialNeeds.specialGuideDogStatus === MmBAppConstants.SPECIAL_NEEDS.SVAN_STATUS.KK.code) {
                        vm.model.messageGuideDogApprove = $filter('literalFormatter')($filter('translate')('IB_PASSENGER_SPE_NEEDS_CHECK_SPECIAL_GUIDE_DOG_INFO_MESSAGE_APPROVED'), tagsInfo);
                        vm.model.messageGuideDogDenied = $filter('literalFormatter')($filter('translate')('IB_PASSENGER_SPE_NEEDS_CHECK_SPECIAL_GUIDE_DOG_INFO_MESSAGE_DENIED'), tagsInfo);
                    }

                });
            }
        }

        /**
         * Selected option
         */
        function checked (index) {
            if (angular.isObject(vm.model.specialNeeds) && (!vm.model.specialNeeds.specialWheelchair || (vm.model.specialNeeds.specialWheelchair && vm.model.specialNeeds.specialWheelchairValue))) {
                vm.modalSpecialNeedsForm['check_chair'].$setValidity('wheelChairValidation', true);
            }
            $rootScope.$emit('checkSpecialNeedsEvent', index);
        }

        /**
         * Closes the modal dismissing its instance
         */
        function closeModal () {
            if (angular.isDefined(vm.showError) && angular.isDefined(vm.submitted)) {
                vm.showError = false;
                vm.submitted = false;
            }

            if (vm.model.type === 'specialNeeds') {
                vm.model.specialNeeds = vm.model.originalSpecialNeeds;
            }

            $uibModalInstance.close();
        }

        function updateEmergencyContactInfo (currentForm) {
            var type = 'emergencyContact';
            currentForm.$submitted = true;
            vm.model.submitted = true;
            vm.model.showError = false;
            vm.model.showOk = false;
            vm.model.showErrorForm = false;
            vm.model.errorMsg = undefined;

            if (currentForm.$valid) {
                CommonsUtilService.setTitlePage('MMB_TITLE_PAGE_EMERGENCY_CONTACT');
                MmBDatalayerUtilsService.updateDatalayerInfo(MMBDatalayerConstants.DIGITAL_DATA_PROCESS.MOCEME, MMBDatalayerConstants.DIGITAL_DATA_STEP.MOCEME, MmBAppConstants.QUADRIGAM.CONFIRM_EMERGENCY_CONTACT);
                MmBDatalayerUtilsService.updateDatalayerViewEvent();
                if (!angular.equals(vm.model.originalData, vm.model.data)) {
                    if (vm.contactForm?.NAME_PREFIX?.$viewValue?.countryCode) {
                        vm.model.data.countryCode = vm.contactForm.NAME_PREFIX.$viewValue.countryCode;
                    }
                    if (Array.isArray(vm.model?.passengersModelCopy?.passengers)) {
                        vm.model.passengersModelCopy.passengers.forEach((passenger) => {
                            passenger.emergencyContactInfo = vm.model.data;
                        });
                    }
                    BookingDashboardService.updateDataContactInfo(vm.model.serviceData.flowId, vm.model.passengersModelCopy, type).then(updateDataContactInfoSuccess, updateDataContactInfoError);
                } else {
                    vm.model.showError = false;
                    vm.model.showOk = true;
                    closeMessageWithTimeout(true);
                }
            } else {
                vm.model.submitted = false;
                vm.model.showOk = false;
                closeMessageWithTimeout(false);
            }
        }

        function updateDataContactInfoSuccess() {
            const bookingInfo = localStorageService.get('bookingInfo');
            vm.model.showError = false;
            vm.model.showOk = true;
            localStorageService.set('savedChangeSuccess', true);
            localStorageService.set('savedPasSuccess', true);
            if (vm.model.passengersModelCopy.passengers) {
                bookingInfo.passengers = vm.model.passengersModelCopy.passengers;
            }
            bookingInfo.passengers[0].emergencyContactInfo = vm.model.data;
            localStorageService.set('bookingInfo', bookingInfo);
            $rootScope.$emit('confirmEmergencyContact', bookingInfo.passengers[0].emergencyContactInfo);
            closeMessageWithTimeout(true);
        }

        function updateDataContactInfoError(error) {
            if (error.messageList && error.messageList.length > 0) {
                vm.model.errorMsg = error.messageList[0].message;
            } else {
                vm.model.errorMsg = $filter('translate')('MMB_PASSENGER_MODAL_ALERT_SUBTITLE_ERROR');
            }
            vm.model.showError = true;
            vm.model.showOk = false;
            closeMessageWithTimeout(false);
        }

        function updateDataContact (currentForm) {
            var bookingInfo = {};
            const custData = localStorageService.get('customerData');
            const prefixMarket = MmBUtilService.getPrefixFromMarket();
            let ibPlusNumber = custData?.personalInfo?.ibPlusNumber ? custData.personalInfo.ibPlusNumber : null;
            const valueChanged = {
                'phone': (vm.model?.phoneDetails) ? (vm.model?.phoneDetails?.countryCode + vm.model?.phoneDetails?.number) : vm.model?.phone,
                'phoneDetails': vm.model?.phoneDetails,
                'email': vm.model?.email,
                'phoneType': 'MOBILE',
                'idIbplus': ibPlusNumber,
                'countryCode': vm.model?.countryCode,
                'language': vm.model?.contactInfo?.language ? vm.model.contactInfo.language : prefixMarket.code
            };
            var modelCopy = {};
            var flowId;
            currentForm.$submitted = true;
            vm.model.submitted = true;
            vm.model.showError = false;
            vm.model.showOk = false;
            vm.model.showErrorForm = false;
            vm.model.errorMsg = undefined;

            if (currentForm.$valid) {
                if (!angular.equals(vm.model.contactInfo, valueChanged)) {
                    modelCopy = angular.copy(vm.model);
                    modelCopy.contactInfo = valueChanged;
                    flowId = localStorageService.get('flowId');
                    if (localStorageService.get('userLogged') && !CommonsUserUtilsService.isSoftUser() && chkPassLogged(valueChanged.idIbplus)) {
                        $rootScope.$broadcast('updateContactDetails', valueChanged);
                    }
                    BookingDashboardService.updateDataContactInfo(flowId, modelCopy, vm.model.type).then(() => {
                        $rootScope.$broadcast('changeContactInfo', modelCopy.contactInfo, vm.model.index);
                        vm.model.showError = false;
                        vm.model.showOk = true;
                        bookingInfo = localStorageService.get('bookingInfo');
                        bookingInfo.passengers[vm.model.index].contactInfo = valueChanged;
                        localStorageService.set('bookingInfo', bookingInfo);
                        closeMessageWithTimeout(true);
                    }, (error) => {
                        vm.model.showError = true;
                        vm.model.showOk = false;
                        if (error.messageList && error.messageList.length > 0) {
                            vm.model.errorMsg = error.messageList[0].message;
                        } else {
                            vm.model.errorMsg = $filter('translate')('MMB_PASSENGER_MODAL_ALERT_SUBTITLE_ERROR');
                        }

                        // Closes & OK Img
                        closeMessageWithTimeout(false);
                    });
                } else {
                    vm.model.submitted = false;
                    vm.model.showOk = false;
                    vm.model.showErrorForm = true;
                    closeMessageWithTimeout(false);
                }
            } else {
                vm.model.submitted = false;
                vm.model.showOk = false;
                vm.model.errorMsg = $filter('translate')('MMB_PASSENGER_MODAL_ALERT_SUBTITLE_ERROR');
                closeMessageWithTimeout(false);
            }

        }

        function updatePersonalInfo (currentForm) {
            var bookingInfo = {}, passengersLocalStorage = {}, quadrigam;
            const prefixMarket = MmBUtilService.getPrefixFromMarket();
            const valueExternalPersonalInfoChanged = {
                'name': (vm.model?.personalInfoEdit?.name),
                'firstSurname': (vm.model?.personalInfoEdit?.surname),
                'lastsurname': null
            };
            const valuePersonalInfoChanged = {
                'name': (vm.model?.personalInfoEdit?.name),
                'surname': (vm.model?.personalInfoEdit?.surname),
                'birthDate': null
            };
            const valueService = {
                'contactInfo': {
                    'email': null,
                    'phone': null
                },
                'firstName': (vm.model?.personalInfoEdit?.name),
                'firstSurname': (vm.model?.personalInfoEdit?.surname),
                'lastSurname': null,
                'birthDate': null
            };


            if (prefixMarket.countryCode === 'ES' && !vm.model.desactiveLastSurname) {
                valueChanged.lastSurname = vm.model?.personalInfoEdit?.lastSurname;
            }
            var modelCopy = {}, modelCopyService = {};
            var flowId;

            currentForm.$submitted = true;
            vm.model.submitted = true;
            vm.model.showError = false;
            vm.model.showOk = false;
            vm.model.showErrorForm = false;
            vm.model.errorTitle = undefined;
            vm.model.errorMsg = undefined;

            if (currentForm.$valid) {
                //if the user not change and pulse button Accept
                if (vm.model.personalInfo.name.trim().replace(/\s+$/, '') + vm.model.personalInfo.surname.trim().replace(/\s+$/, '') !== valuePersonalInfoChanged.name + valuePersonalInfoChanged.surname) {
                    modelCopy = angular.copy(vm.model);
                    modelCopy.personalInfo = valuePersonalInfoChanged;
                    modelCopy.externalPersonalInfo = valueExternalPersonalInfoChanged;
                    modelCopyService.personalInfo = valueService;
                    modelCopyService.passengerId = vm.model.passengerId;
                    flowId = localStorageService.get('flowId');
                    BookingDashboardService.updateDataPersonalInfo(flowId, modelCopyService, vm.model.type).then((data) => {
                        let allModifiedPersonalInfo = [], elementModified = {}, nameComplete = '';
                        vm.model.showError = false;
                        vm.model.showOk = true;
                        passengersLocalStorage = localStorageService.get('passengers') ? localStorageService.get('passengers') : [];
                        bookingInfo = localStorageService.get('bookingInfo');

                        quadrigam = MmBAppConstants.QUADRIGAM.MODAL_CORRECTION_NAME_CONFIRMATION;
                        MmBDatalayerUtilsService.updateDatalayerInfo(MMBDatalayerConstants.DIGITAL_DATA_PROCESS[quadrigam],MMBDatalayerConstants.DIGITAL_DATA_STEP[quadrigam], quadrigam);

                        bookingInfo.passengers.map(passenger => {
                            let nameReceiveImport = passenger.externalPersonalInfo ? passenger.externalPersonalInfo.name : passenger.personalInfo.name;
                            let surnameReceiveImport = passenger.externalPersonalInfo ? passenger.externalPersonalInfo.firstSurname : passenger.personalInfo.surname;
                            elementModified = {};
                            elementModified.name = nameReceiveImport + surnameReceiveImport;
                            elementModified.modifiedPersonalInfo = passenger.modifiedPersonalInfo ? passenger.modifiedPersonalInfo : null;
                            allModifiedPersonalInfo.push(elementModified);
                        });

                        data.data.passengers.forEach(dataPassenger => {
                            if (dataPassenger.externalPersonalInfo) {
                                if (modelCopy.externalPersonalInfo.name === dataPassenger.externalPersonalInfo.name && modelCopy.externalPersonalInfo.firstSurname === dataPassenger.externalPersonalInfo.firstSurname) {
                                    modelCopy.oldPassengerId = modelCopy.passengerId;
                                    modelCopy.passengerId = dataPassenger.passengerId;
                                }
                            } else {
                                if (modelCopy.personalInfo.name === dataPassenger.personalInfo.firstName && modelCopy.personalInfo.surname === dataPassenger.personalInfo.firstSurname) {
                                    modelCopy.oldPassengerId = modelCopy.passengerId;
                                    modelCopy.passengerId = dataPassenger.passengerId;
                                }
                            }


                            bookingInfo.passengers.map(passenger => {
                                if (dataPassenger.passengerId === passenger.passengerId) {
                                    if (dataPassenger.externalPersonalInfo) {
                                        passenger.externalPersonalInfo.name = dataPassenger.externalPersonalInfo.name;
                                        passenger.externalPersonalInfo.firstSurname = dataPassenger.externalPersonalInfo.firstSurname;
                                        passenger.externalPersonalInfo.lastSurname = dataPassenger.externalPersonalInfo.lastSurname ? dataPassenger.externalPersonalInfo.lastSurname : '';
                                        passenger.externalPersonalInfo.birthDate = dataPassenger.externalPersonalInfo ? (dataPassenger.externalPersonalInfo.birthDate ? dataPassenger.externalPersonalInfo.birthDate : null) : (dataPassenger.personalInfo.birthDate ? dataPassenger.personalInfo.birthDate : null);
                                    }
                                    passenger.personalInfo.name = dataPassenger.personalInfo.firstName;
                                    passenger.personalInfo.surname = dataPassenger.personalInfo.firstSurname;
                                    passenger.personalInfo.birthDate = dataPassenger.personalInfo.birthDate ? dataPassenger.personalInfo.birthDate : null;
                                    //ExternalPersonalInfo does not come from service (GAP)
                                    // if (passenger.externalPersonalInfo) {
                                    //     passenger.externalPersonalInfo = null;
                                    // }
                                }
                            });

                            if (passengersLocalStorage.length > 0){
                                passengersLocalStorage.map(passenger => {
                                    if (dataPassenger.passengerId === passenger.passengerId) {
                                        if (dataPassenger.externalPersonalInfo) {
                                            passenger.externalPersonalInfo.name = dataPassenger.externalPersonalInfo.name;
                                            passenger.externalPersonalInfo.firstSurname = dataPassenger.externalPersonalInfo.firstSurname;
                                            passenger.externalPersonalInfo.lastSurname = dataPassenger.externalPersonalInfo.lastSurname ? dataPassenger.externalPersonalInfo.lastSurname : '';
                                            passenger.externalPersonalInfo.birthDate = dataPassenger.externalPersonalInfo ? (dataPassenger.externalPersonalInfo.birthDate ? dataPassenger.externalPersonalInfo.birthDate : null) : (dataPassenger.personalInfo.birthDate ? dataPassenger.personalInfo.birthDate : null);
                                        }
                                        passenger.personalInfo.name = dataPassenger.personalInfo.firstName;
                                        passenger.personalInfo.surname = dataPassenger.personalInfo.firstSurname;
                                        passenger.personalInfo.birthDate = dataPassenger.personalInfo.birthDate ? dataPassenger.personalInfo.birthDate : null;
                                        // if (passenger.externalPersonalInfo) {
                                        //     passenger.externalPersonalInfo = null;
                                        // }
                                    }
                                });
                            }
                        });

                        bookingInfo.passengers.map(passenger => {
                            if (modelCopy.oldPassengerId !== modelCopy.passengerId) {
                                //RESET MODIFIED INTERNAL FLAG
                                passenger.modifiedPersonalInfo = false;

                                //OLD PASSENGERS MODIFIED TO TRUE
                                allModifiedPersonalInfo.forEach(element =>{
                                    nameComplete = passenger.externalPersonalInfo ? passenger.externalPersonalInfo.name + passenger.externalPersonalInfo.firstSurname : passenger.personalInfo.name + passenger.personalInfo.surname;
                                    if (element.modifiedPersonalInfo === true && element.name === nameComplete) {
                                        passenger.modifiedPersonalInfo = true;
                                    }
                                });
                            }
                            //ACTUAL PASSENGER MODIFIED
                            if (modelCopy.externalPersonalInfo && passenger.externalPersonalInfo) {
                                if (modelCopy.externalPersonalInfo.name === passenger.externalPersonalInfo.name && modelCopy.externalPersonalInfo.firstSurname === passenger.externalPersonalInfo.firstSurname) {
                                    passenger.modifiedPersonalInfo = true;
                                }
                            } else {
                                if (modelCopy.personalInfo.name === passenger.personalInfo.name && modelCopy.personalInfo.surname === passenger.personalInfo.surname) {
                                    passenger.modifiedPersonalInfo = true;
                                }
                            }

                        });

                        localStorageService.set('bookingInfo', bookingInfo);
                        $rootScope.$broadcast('updatePersonalInfo', data, modelCopy, allModifiedPersonalInfo);
                        closeMessageWithTimeout(true);
                    }, (error) => {
                        vm.model.showError = true;
                        vm.model.showOk = false;
                        vm.model.errorCode = error.errorCode;
                        vm.model.internalErrorCode = error.internalErrorCode;
                        if (error.errorCode === 412 && error.internalErrorCode === MmBAppConstants.WARNING_MESSAGES.CORRECTION_NAME_NOT_PERMITED) {
                            let message = error?.message.split('/');
                            // vm.model.errorTitle = $filter('translate')('MMB_PASSENGERS_PERSONAL_DATA_MODAL_NOT_REALICED');
                            vm.model.errorTitle = message[0] ? message[0] : $filter('translate')('MMB_PASSENGERS_PERSONAL_DATA_MODAL_NOT_REALICED');
                            vm.model.errorMsg = message[1] ? message[1] : $filter('translate')('MMB_PASSENGERS_PERSONAL_DATA_MODAL_NOT_INCLUIDED');
                            quadrigam = MmBAppConstants.QUADRIGAM.MODAL_CORRECTION_NAME_ERROR;

                        } else {
                            vm.model.errorTitle = $filter('translate')('MMB_PASSENGERS_PERSONAL_DATA_MODAL_ERROR_CORRECTED');
                            vm.model.errorMsg = $filter('translate')('MMB_PASSENGERS_PERSONAL_DATA_MODAL_ERROR_TRY_AGAIN');
                            quadrigam = MmBAppConstants.QUADRIGAM.MODAL_CORRECTION_NAME_ERROR_SERVICE;
                        }
                        MmBDatalayerUtilsService.updateDatalayerInfo(MMBDatalayerConstants.DIGITAL_DATA_PROCESS[quadrigam],MMBDatalayerConstants.DIGITAL_DATA_STEP[quadrigam], quadrigam);

                        // Closes & OK Img
                        closeMessageWithTimeout(false);
                    });
                } else {
                    closeMessageWithTimeout(true);
                }
            } else {
                vm.model.submitted = false;
                vm.model.showOk = false;
                vm.model.errorMsg = $filter('translate')('MMB_PASSENGER_MODAL_ALERT_SUBTITLE_ERROR');
                closeMessageWithTimeout(false);
            }

        }

        function chkPassLogged (passengerFF) {
            try {
                const custData = localStorageService.get('customerData');
                return passengerFF === custData.personalInfo.ibPlusNumber;
            } catch (error) {
                return false;
            }
        }

        /**
         * Validates the form and then emits an event or scroll to the element with errors
         * @param {*} currentForm form that has been completed
         * @param {*} index Identificator of the passenger in passengersModel
         * @param {*} type type of data that has been provided
         */
        function updateFrequentFlyerContactInfo (currentForm, index, type) {
            var flowId = localStorageService.get('flowId');
            var orderId = localStorageService.get('bookingInfo').order.orderId;
            vm.model.showError = false;
            vm.model.showOk = false;
            vm.model.showErrorForm = false;
            vm.model.showPatternError = false;

            if (currentForm.$valid && type === 'frequentFlyer') {
                currentForm.$submitted = true;
                vm.model.submitted = true;
                if (vm.tempFrequentFlyerInfo.company === 'IB') {
                    if (vm.tempFrequentFlyerInfo.number.length > 4 && vm.tempFrequentFlyerInfo.number.length <= 14) {
                        vm.model.frequentFlyerInfo = vm.tempFrequentFlyerInfo;
                        updateDataContactInfo(flowId, vm.model, index, type);
                    } else {
                        vm.model.showError = true;
                        vm.model.showOk = false;
                        vm.model.submitted = false;
                        vm.model.showErrorForm = true;
                        vm.model.showPatternError = true;
                        closeMessageWithTimeout(true);
                    }
                } else {
                    if (vm.tempFrequentFlyerInfo.number.length <= 20) {
                        vm.model.frequentFlyerInfo = vm.tempFrequentFlyerInfo;
                        updateDataContactInfo(flowId, vm.model, index, type);
                    } else {
                        vm.model.showError = true;
                        vm.model.showOk = false;
                        vm.model.submitted = false;
                        vm.model.showErrorForm = true;
                        vm.model.showPatternError = false;
                        closeMessageWithTimeout(true);
                    }
                }
            } else {
                vm.model.submitted = false;
                vm.model.showErrorForm = true;
                vm.model.showOk = false;
                vm.model.errorMsg = $filter('translate')('MMB_PASSENGER_MODAL_ALERT_SUBTITLE_ERROR');
                closeMessageWithTimeout(false);
            }
        }

        function updateDataContactInfo (flowId, data, index, type) {
            BookingDashboardService.updateDataContactInfo(flowId, data, type).then(function () {
                var ffLocal;
                var ffLocalAux;
                var bookingInfo;
                var x;
                vm.model.showError = false;
                vm.model.showOk = true;
                localStorageService.set('savedPasSuccess', true);
                localStorageService.set('savedChangeSuccess', true);
                localStorageService.set('modifyFFOrSpecialNeed', true);
                bookingInfo = localStorageService.get('bookingInfo');
                ffLocal = localStorageService.get('ffLocal');
                ffLocal = ffLocal ? ffLocal : [];

                for (x = 0; x < ffLocal.length; x++) {
                    if (ffLocal[x].id === data.passengerId) {
                        ffLocal[x].allCompany.push({
                            company: data.frequentFlyerInfo.company,
                            number: data.frequentFlyerInfo.number
                        });
                        getNameCompany(data);
                        ffLocalAux = ffLocal[x].allCompany;
                    }
                }

                ffLocalAux = getNameCompany(ffLocalAux, data);

                bookingInfo.passengers[index].additionalFFInfo = ffLocalAux;
                localStorageService.set('bookingInfo', bookingInfo);
                localStorageService.set('ffLocal', ffLocal);
                $rootScope.$emit('updateModelFf', ffLocalAux, index);
                CommonsUtilService.setTitlePage('MMB_TITLE_FRECUENT_PASSENGERS_ADD');
                MmBDatalayerUtilsService.updateDatalayerInfo(MMBDatalayerConstants.DIGITAL_DATA_PROCESS.MOCFFL, MMBDatalayerConstants.DIGITAL_DATA_STEP.MOCFFL, MmBAppConstants.QUADRIGAM.CONFIRM_FF);
                MmBDatalayerUtilsService.updateDatalayerViewEvent();
                closeMessageWithTimeout(true);
            }, function (error) {
                if (error.messageList && error.messageList.length > 0) {
                    vm.model.errorMsg = error.messageList[0].message;
                } else if (error.message) {
                    vm.model.errorMsg = error.message;
                } else {
                    vm.model.errorMsg = $filter('translate')('MMB_PASSENGER_MODAL_ALERT_SUBTITLE_ERROR');
                }
                vm.model.showError = true;
                vm.model.showOk = false;
                closeMessageWithTimeout(false);
            });
        }

        function getNameCompany (ffLocalAux, data) {
            var x, y;
            for (x = 0; x < ffLocalAux.length; x++) {
                for (y = 0; y < data.frequentFlyersCompanies.length; y++) {
                    if (ffLocalAux[x].company === data.frequentFlyersCompanies[y].iataCompanyCode) {
                        ffLocalAux[x].airlineName = data.frequentFlyersCompanies[y].airlineName;
                    }
                }
            }
            return ffLocalAux;
        }

        function updateSpecialNeedsContactInfo (currentForm) {
            var arraySpecialNeeds = [];
            var flowId = localStorageService.get('flowId');
            var isFormOk = false;
            var isIncludeWheelChair = false;

            if (angular.isObject(vm.model.specialNeeds)) {
                for (let i = 0; i < MmBAppConstants.SPECIAL_NEEDS.CODE.WHEEL_CHAIR.length; i++) {
                    const codeWheelChair = MmBAppConstants.SPECIAL_NEEDS.CODE.WHEEL_CHAIR[i];
                    if (!isIncludeWheelChair && vm.model.specialNeeds.specialWheelchairValue === codeWheelChair) {
                        isIncludeWheelChair = true;
                    }
                }
            }

            isFormOk = angular.isObject(vm.model.specialNeeds) && vm.model.specialNeeds.specialWheelchair ? currentForm.$valid && vm.model.specialNeeds && vm.model.specialNeeds !== null && vm.model.specialNeeds.specialWheelchair && isIncludeWheelChair : currentForm.$valid && vm.model.specialNeeds && vm.model.specialNeeds !== null && (vm.model.specialNeeds.specialGuideDog || vm.model.specialNeeds.specialHearing || vm.model.specialNeeds.specialIntellectual || vm.model.specialNeeds.specialVision || (vm.model.specialNeeds.specialWheelchair && isIncludeWheelChair));
            currentForm.$submitted = true;
            vm.model.submitted = true;
            vm.model.showError = false;
            vm.model.showOk = false;
            vm.model.showErrorForm = false;

            if (isFormOk) {
                if (vm.model.specialNeeds.specialVision) {
                    arraySpecialNeeds.push({
                        'serviceCode': MmBAppConstants.SPECIAL_NEEDS.CODE.BLND
                    });
                }
                if (vm.model.specialNeeds.specialIntellectual) {
                    arraySpecialNeeds.push({
                        'serviceCode': MmBAppConstants.SPECIAL_NEEDS.CODE.DPNA
                    });
                }
                if (vm.model.specialNeeds.specialHearing) {
                    arraySpecialNeeds.push({
                        'serviceCode': MmBAppConstants.SPECIAL_NEEDS.CODE.DEAF
                    });
                }
                if (vm.model.specialNeeds.specialGuideDog) {
                    arraySpecialNeeds.push({
                        'serviceCode': MmBAppConstants.SPECIAL_NEEDS.CODE.SVAN
                    });
                }
                if (vm.model.specialNeeds.specialWheelchair && vm.model.specialNeeds.specialWheelchairValue !== '') {
                    arraySpecialNeeds.push({
                        'serviceCode': vm.model.specialNeeds.specialWheelchairValue
                    });
                }
                vm.model.specialNeeds.values = arraySpecialNeeds;
                if (vm.modelOld) {
                    vm.modelOld.values = eliminateValues(vm.modelOld);
                }

                const custData = localStorageService.get('customerData');
                var ibPlusNumber = custData?.personalInfo?.ibPlusNumber ? custData.personalInfo.ibPlusNumber : null;

                var isEqual = compareObj(vm.model.specialNeeds, vm.modelOld);
                if (!isEqual && chkPassLogged(ibPlusNumber) && !CommonsUserUtilsService.isIbZero() && !CommonsUserUtilsService.isSoftUser()) {
                    $rootScope.$broadcast('specialNeedForm', currentForm);
                }
                BookingDashboardService.updatePassengerSpecialNeeds(flowId, vm.model).then(function (data) {
                    vm.model.showError = false;
                    vm.model.showOk = true;
                    vm.specialNeedsChange = true;
                    localStorageService.set('savedPasSuccess', true);
                    localStorageService.set('savedChangeSuccess', true);
                    localStorageService.set('modifyFFOrSpecialNeed', true);
                    updateStatusSpecialNeeds(data);
                    closeMessageWithTimeout(true);
                }, function (error) {
                    if (error.messageList && error.messageList.length > 0) {
                        vm.model.errorMsg = error.messageList[0].message;
                    } else if (error.message) {
                        vm.model.errorMsg = error.message;
                    } else {
                        vm.model.errorMsg = $filter('translate')('MMB_PASSENGER_MODAL_ALERT_SUBTITLE_ERROR');
                    }
                    vm.model.showError = true;
                    vm.model.showOk = false;
                    closeMessageWithTimeout(false);
                });
            } else {
                vm.model.submitted = false;
                vm.model.showError = true;
                vm.model.showOk = false;
                if (vm.model.specialNeeds && angular.isObject(vm.model.specialNeeds) && vm.model.specialNeeds.specialWheelchair && !vm.model.specialNeeds.specialWheelchairValue) {
                    vm.model.showError = false;
                    vm.model.errorMsg = $filter('translate')('IB_PASSENGER_SPE_NEEDS_CHECK_MANDATORY');
                    vm.modalSpecialNeedsForm['check_chair'].$setValidity('wheelChairValidation', false);
                    closeMessage(false);
                } else {
                    vm.model.errorMsg = $filter('translate')('IB_PASSENGER_SPE_NEEDS_CHECK_MANDATORY_BASIC');
                    vm.modalSpecialNeedsForm['check_chair'].$setValidity('wheelChairValidation', true);
                    closeMessage(false);
                }

            }
        }

        function updateStatusSpecialNeeds (response) {
            var passengersID = localStorageService.get('specialNeedsPassengersEdit'), existSpecialNeed = null, arrPassengerId = null, arrTypes = null, groupTypes = null;
            if (passengersID && passengersID.length > 0 && response && response.order && response.order.orderItems) {
                existSpecialNeed = MmBUtilService.groupByKey(response.order.orderItems, 'type');

                if (existSpecialNeed !== null && angular.isDefined(existSpecialNeed.specialNeed)) {
                    arrPassengerId = MmBUtilService.groupByKey(response.order.orderItems, 'passengerId');
                    arrTypes = MmBUtilService.groupByKey(arrPassengerId[passengersID], 'type');
                    groupTypes = MmBUtilService.groupByKey(arrTypes['specialNeed'], 'serviceCode');

                    for (let i = 0; i < vm.model.specialNeeds.values.length; i++) {
                        const value = vm.model.specialNeeds.values[i];
                        if (groupTypes[MmBAppConstants.SPECIAL_NEEDS.CODE.WHEEL_CHAIR[0]] && groupTypes[MmBAppConstants.SPECIAL_NEEDS.CODE.WHEEL_CHAIR[0]].length > 0 &&
                            value.serviceCode === MmBAppConstants.SPECIAL_NEEDS.CODE.WHEEL_CHAIR[0])
                            value['status'] = groupTypes[MmBAppConstants.SPECIAL_NEEDS.CODE.WHEEL_CHAIR[0]][0].status;
                        if (groupTypes[MmBAppConstants.SPECIAL_NEEDS.CODE.WHEEL_CHAIR[1]] && groupTypes[MmBAppConstants.SPECIAL_NEEDS.CODE.WHEEL_CHAIR[1]].length > 0 &&
                            value.serviceCode === MmBAppConstants.SPECIAL_NEEDS.CODE.WHEEL_CHAIR[1])
                            value['status'] = groupTypes[MmBAppConstants.SPECIAL_NEEDS.CODE.WHEEL_CHAIR[1]][0].status;
                        if (groupTypes[MmBAppConstants.SPECIAL_NEEDS.CODE.WHEEL_CHAIR[2]] && groupTypes[MmBAppConstants.SPECIAL_NEEDS.CODE.WHEEL_CHAIR[2]].length > 0 &&
                            value.serviceCode === MmBAppConstants.SPECIAL_NEEDS.CODE.WHEEL_CHAIR[2])
                            value['status'] = groupTypes[MmBAppConstants.SPECIAL_NEEDS.CODE.WHEEL_CHAIR[2]][0].status;
                        if (groupTypes[MmBAppConstants.SPECIAL_NEEDS.CODE.SVAN] && groupTypes[MmBAppConstants.SPECIAL_NEEDS.CODE.SVAN].length > 0 &&
                            value.serviceCode === MmBAppConstants.SPECIAL_NEEDS.CODE.SVAN)
                            value['status'] = groupTypes[MmBAppConstants.SPECIAL_NEEDS.CODE.SVAN][0].status;
                        if (groupTypes[MmBAppConstants.SPECIAL_NEEDS.CODE.DEAF] && groupTypes[MmBAppConstants.SPECIAL_NEEDS.CODE.DEAF].length > 0 &&
                            value.serviceCode === MmBAppConstants.SPECIAL_NEEDS.CODE.DEAF)
                            value['status'] = groupTypes[MmBAppConstants.SPECIAL_NEEDS.CODE.DEAF][0].status;
                        if (groupTypes[MmBAppConstants.SPECIAL_NEEDS.CODE.BLND] && groupTypes[MmBAppConstants.SPECIAL_NEEDS.CODE.BLND].length > 0 &&
                            value.serviceCode === MmBAppConstants.SPECIAL_NEEDS.CODE.BLND)
                            value['status'] = groupTypes[MmBAppConstants.SPECIAL_NEEDS.CODE.BLND][0].status;
                        if (groupTypes[MmBAppConstants.SPECIAL_NEEDS.CODE.DPNA] && groupTypes[MmBAppConstants.SPECIAL_NEEDS.CODE.DPNA].length > 0 &&
                            value.serviceCode === MmBAppConstants.SPECIAL_NEEDS.CODE.DPNA)
                            value['status'] = groupTypes[MmBAppConstants.SPECIAL_NEEDS.CODE.DPNA][0].status;
                    }
                }
            }
        }

        function closeMessageWithTimeout (closeModal) {
            $timeout(function () {
                if (vm.model.showError) {
                    vm.model.showErrorForm = true;
                }
                vm.model.submitted = false;
                vm.model.showError = false;
                vm.model.showOk = false;
                if (closeModal) {
                    $uibModalInstance.close();
                }
            }, 3000);
        }

        function closeMessage (closeModal) {
            if (vm.model.showError) {
                vm.model.showErrorForm = true;
            }
            vm.model.submitted = false;
            vm.model.showError = false;
            vm.model.showOk = false;
            if (closeModal) {
                $uibModalInstance.close();
            }
        }

        function areEmailsEquals () {
            var contactEmail = vm.model.email || '';
            var repeatedEmail = vm.model.emailRepeat || '';
            vm.hasEquals = contactEmail.toLowerCase() === repeatedEmail.toLowerCase();
            if (angular.isDefined(vm.modalContactForm)) {
                vm.modalContactForm.emailRepeat.$setValidity('emailsNotEqual', vm.hasEquals);
            }
        }

        function resetOriginalSpecialNeeds () {
            if (!vm.specialNeedsChange) {
                vm.model.specialNeeds = vm.model.originalSpecialNeeds;
            }
        }

        function checkStatusSVAN (status) {
            if (status === 'UC' || status === 'UN') {
                return 'denied';
            } else if (status === 'HK' || status === 'KK') {
                return 'approved';
            } else if (status === 'HN') {
                return 'pending';
            } else {
                return false;
            }
        }

        function compareObj (obj1, obj2) {
            let obj1String = JSON.stringify(obj1);
            let obj2String = JSON.stringify(obj2);

            return obj1String === obj2String;
        }

        function eliminateValues (objt) {
            let objTemp = [];
            if (objt) {
                for (let index = 0; index < objt.values.length; index++) {
                    objTemp.push({ 'serviceCode': objt.values[index].serviceCode });
                }
                return objt.values = objTemp;
            } else {
                return objt;
            }

        }

        function checkPersonalInfoChanges() {
            vm.hasEquals = true;
            let originalName = vm.model.personalInfo.name;
            let updatedName = vm.model.personalInfoEdit.name;
            let originalSurname = vm.model.personalInfo.surname;
            let updatedSurname = vm.model.personalInfoEdit.surname;
            let originalNameNoSpaces = originalName.trim().replace(/\s+$/, '');
            let updatedNameNoSpaces = updatedName.trim().replace(/\s+$/, '');
            let originalSurnameNoSpaces = originalSurname.trim().replace(/\s+$/, '');
            let updatedSurnameNoSpaces = updatedSurname.trim().replace(/\s+$/, '');
            if (originalNameNoSpaces === updatedNameNoSpaces && originalSurnameNoSpaces === updatedSurnameNoSpaces) {
                vm.disableUpdatePersonaInfoAction = true;
            } else {
                vm.disableUpdatePersonaInfoAction = false;
            }
        }
    }
})();
